import { Box } from '@mui/material'
import { useState } from 'react'
import { CommentWithReplies } from '../../models/Comment'
import { ConstructionTab } from '../../reducers/construction'
import CommentComponent from './CommentComponent'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { Can } from '../../utils/AbilityUtil'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'

interface ManageCommentProps {
  tab: ConstructionTab
  comment: CommentWithReplies
}

const ManageCommentComponent: React.FC<ManageCommentProps> = ({
  tab,
  comment,
}) => {
  const [showComment, setShowComment] = useState(false)
  const author = useSelector((state: RootState) =>
    state.organization.users?.find((user) => user.id === comment.author_id),
  )
  const usersColors =
    useSelector((state: RootState) => state.organization.userColors) ?? []
  const color = usersColors.find((uc) => uc.id === author?.id)?.color
  const initials = author
    ? author.user_name
        .split(' ')
        .map((item) => item.charAt(0))
        .join('')
        .toUpperCase()
    : ''

  const handleCommentIconClick = () => {
    setShowComment(!showComment)
  }

  return (
    <Can I={AttributeActionNames.Read} a={AttributeResourceNames.Comments}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          top: comment.positionY,
          left: comment.positionX,
          zIndex: 100,
          cursor: 'pointer',
        }}
      >
        <Box
          onClick={handleCommentIconClick}
          sx={{
            pb: '5px',
          }}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='33'
            height='33'
            viewBox='0 0 33 33'
            fill='none'
          >
            <circle cx='16.5' cy='16.5' r='16.5' fill={color} />
            <rect y='16' width='17' height='17' fill={color} />
            <circle cx='16.5' cy='16.5' r='13.86' fill='#fff' opacity={0.5} />
            <text
              x='50%'
              y='50%'
              textAnchor='middle'
              dy='.3em'
              fontSize='15'
              fill='#141414'
              fontWeight='bold'
            >
              {initials}
            </text>
          </svg>
        </Box>
        {showComment && (
          <Box
            sx={{
              width: '309px',
              p: '11px',
              background: 'white',
              borderRadius: '6px',
              boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.25)',
            }}
          >
            <CommentComponent
              tab={tab}
              comment={comment}
              showReactions={true}
              showResolve={true}
            />
          </Box>
        )}
      </Box>
    </Can>
  )
}

export default ManageCommentComponent
